import { render, staticRenderFns } from "./example.vue?vue&type=template&id=73e556f9&scoped=true"
import script from "./example.vue?vue&type=script&lang=js"
export * from "./example.vue?vue&type=script&lang=js"
import style0 from "./example.vue?vue&type=style&index=0&id=73e556f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e556f9",
  null
  
)

export default component.exports